<template>
  <fragment>
    <td class="select-item-column" width="300px">
      <item-select
        v-model="component.name"
        :items="items"
        @reload="reloadItemList"
      />
    </td>

    <td>
      <input
        type="number"
        class="form-control"
        v-model="component.total"
        placeholder="0"
      />
    </td>
    <td>
      <input
        type="number"
        class="form-control"
        v-model="component.carton"
        placeholder="0"
      />
    </td>
    <td>
      <button class="btn btn-danger" @click="deleteComponentRow(index)">
        <i class="fa fa-trash-o" aria-hidden="true"></i>
      </button>
    </td>
  </fragment>
</template>

<script>
import ItemSelect from "./ItemSelect";
import { Fragment } from "vue-fragment";
export default {
  name: "ShipmentComponentDetail",
  components: {
    ItemSelect,
    Fragment,
  },
  props: ["component", "deleteComponentRow", "items", "index"],
  data() {
    return { switchToManualInput: !this.items.includes(this.component.name) };
  },
  methods: {
    reloadItemList(event) {
      this.$emit("reload");
    },
  },
};
</script>
<style scoped>
.select-item-column .input-switcher {
  position: absolute;
  bottom: -8px;
  left: 13px;
  font-size: 12px;
  color: var(--primary-color);
  cursor: pointer;
}
td {
  position: relative;
  padding: 20px 12px !important;
}
</style>
